import React from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import Seo from "../seo/Seo";
import { Section, Heading, PageHero, CTASection, Bullets, FAQ, faqSchema } from "../components/ui-kit";
import { IMAGES } from "../mock/mock";
import { CITIES, FAQS } from "../data/site";

const CityPage = () => {
  const { slug } = useParams();
  const data = CITIES[slug];
  if (!data) return <Navigate to="/locations" replace />;
  const breadcrumbs = [
    { name: "Home", path: "/" }, { name: "Locations", path: "/locations" },
    { name: data.county, path: `/locations/${data.countySlug}` },
    { name: data.name, path: `/locations/${slug}` },
  ];
  const localFaqs = [
    { q: `Does Build Highland Homes build custom homes in ${data.name}, Florida?`, a: `Yes. Build Highland Homes designs and builds custom homes in ${data.name}, ${data.county}. Every home is built on your lot.` },
    { q: `Can I build on my own lot in ${data.name}?`, a: `Absolutely. All of our ${data.name} homes are built on your lot or land, starting with a property-specific evaluation of access, utilities, drainage, and setbacks.` },
    ...FAQS.slice(4, 6),
  ];
  return (
    <>
      <Seo
        title={`Custom Home Builder in ${data.name}, Florida | Build Highland Homes`}
        description={`Custom home builder in ${data.name}, ${data.county}. Build Highland Homes designs and builds custom homes on your lot in ${data.name}, Florida.`}
        path={`/locations/${slug}`}
        keywords={`custom home builder ${data.name.toLowerCase()}, custom homes ${data.name.toLowerCase()} florida, build a custom home ${data.name.toLowerCase()}`}
        breadcrumbs={breadcrumbs}
        schema={faqSchema(localFaqs)}
      />
      <PageHero overline={`${data.county}, Florida`} title={`Custom Home Builder in ${data.name}, Florida`} subtitle={data.blurb} image={IMAGES.newHomeBuild} />

      <Section className="bg-[#0b0b0b]">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <div>
            <Heading center={false} overline="Local Custom Home Building" title={`Building a Custom Home in ${data.name}`} subtitle={`As a custom home builder serving ${data.name}, we design and build homes tailored to your lot and the character of the area.`} />
            <p className="text-[#a39d90] leading-relaxed mb-6">Every home in {data.name} is a build-on-your-lot custom home. We begin with a property-specific evaluation, then design a home that fits your site and lifestyle.</p>
            <h3 className="font-serif-display text-xl text-[#e3c77a] mb-4">{data.name} Building Considerations</h3>
            <Bullets items={data.considerations} />
          </div>
          <div className="bg-[#141414] border border-[#c9a24b]/15 p-7">
            <h3 className="font-serif-display text-xl text-[#e3c77a] mb-4">Nearby Areas We Serve</h3>
            <div className="flex flex-wrap gap-2 mb-6">
              {data.nearby.map((n) => <span key={n} className="text-xs border border-[#c9a24b]/40 text-[#e3c77a] px-3 py-1.5">{n}</span>)}
            </div>
            <Link to={`/locations/${data.countySlug}`} className="text-sm text-[#c9a24b] hover:text-[#e3c77a]">← All of {data.county}</Link>
          </div>
        </div>
      </Section>

      <Section className="bg-[#0f0f0f]">
        <Heading overline="Questions" title={`Custom Homes in ${data.name} — FAQs`} />
        <FAQ items={localFaqs} />
      </Section>

      <CTASection title={`Build Your Custom Home in ${data.name}`} />
    </>
  );
};

export default CityPage;
